<ng-progress aria-label="Page loading"></ng-progress>
<div #splashScreen class="m-splash-screen">
  <div class="page-loading">
    <div class="wrap-loader">
      <div class="item">
        <img src="../assets/images/ajax-loader.gif" alt="Loading">
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet> 